import Link from 'next/link';
import type { FC } from 'react';
import { cn } from '@/utils/cn';
import type { NavItem } from '@/utils/navigation.utils';
import {
  generatePathWithExistingPrefix,
  NavItemType,
} from '@/utils/navigation.utils';

export const MenuItem: FC<{
  item: NavItem;
  currentPath: string;
  isActive: boolean;
  isNarrow?: boolean;
}> = ({ item, currentPath, isActive, isNarrow = false }) => {
  const href = generatePathWithExistingPrefix({
    currentPath,
    targetPath: item.path,
    matchGamePrefix: item.navItemType === NavItemType.GamePage,
  });

  return (
    <Link
      className={cn(
        'flex h-12 items-center gap-2 rounded-lg border border-transparent pl-3 font-medium text-base transition-colors',
        isActive && 'border-light-blue-o50 bg-light-blue-o10 font-bold',
        isNarrow && 'h-8'
      )}
      href={href}
    >
      {item.icon} {item.name}
    </Link>
  );
};
